import React from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from '../components/Layout'
import { Upload, FileCheck, FolderOpen } from 'lucide-react'
import { Button } from '../components/ui/button'

const Dashboard = () => {
  const navigate = useNavigate()

  const actions = [
    {
      title: 'Upload Medicine',
      description: 'Upload medicine delivery challan and extract data',
      icon: Upload,
      action: () => navigate('/upload'),
      testId: 'upload-action'
    },
    {
      title: 'All Medicine Sets',
      description: 'View all saved medicine sets',
      icon: FolderOpen,
      action: () => navigate('/all-sets'),
      testId: 'all-sets-action'
    },
    {
      title: 'Upload Surgical Items',
      description: 'Upload surgical delivery challan and extract data',
      icon: Upload,
      action: () => navigate('/upload-surgical'),
      testId: 'upload-surgical-action'
    },
    {
      title: 'All Surgical Sets',
      description: 'View all saved surgical item sets',
      icon: FolderOpen,
      action: () => navigate('/all-surgical-sets'),
      testId: 'all-surgical-sets-action'
    }
  ]

  return (
    <Layout title="Dashboard">
      <div className="card" data-testid="welcome-card">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">Welcome to Medicine Upload!</h2>
        <p className="text-gray-600">Manage your medicine uploads with ease. Upload delivery challan images and let OCR extract the data.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {actions.map((item) => (
          <div key={item.title} className="card hover:shadow-lg transition-shadow" data-testid={item.testId}>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-teal-100 flex items-center justify-center flex-shrink-0">
                <item.icon className="w-6 h-6 text-teal-700" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 mb-4">{item.description}</p>
                <Button onClick={item.action} data-testid={`${item.testId}-button`}>
                  {item.title === 'Upload' ? 'Upload Now' : 'View All'}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card mt-6" data-testid="workflow-card">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Workflow</h3>
        <ol className="space-y-3 text-gray-700">
          <li className="flex items-start">
            <span className="font-semibold text-teal-700 mr-2">1.</span>
            <span><strong>Upload:</strong> Upload delivery challan image (PNG, JPG, PDF) - OCR extracts data</span>
          </li>
          <li className="flex items-start">
            <span className="font-semibold text-teal-700 mr-2">2.</span>
            <span><strong>Verify:</strong> Review extracted data, edit if needed, and verify all mandatory fields</span>
          </li>
          <li className="flex items-start">
            <span className="font-semibold text-teal-700 mr-2">3.</span>
            <span><strong>Name Set:</strong> Give a name to your medicine set</span>
          </li>
          <li className="flex items-start">
            <span className="font-semibold text-teal-700 mr-2">4.</span>
            <span><strong>Push to eHCMS:</strong> Download Excel file in the required format</span>
          </li>
        </ol>
      </div>
    </Layout>
  )
}

export default Dashboard